import { Header } from "@/components/landing/Header";
import { ServiceSelector } from "@/components/landing/ServiceSelector";
import { GDSection } from "@/components/landing/GDSection";
import { InstallationSection } from "@/components/landing/InstallationSection";
import { Testimonials } from "@/components/landing/Testimonials";
import { LeadForm } from "@/components/landing/LeadForm";
import { Footer } from "@/components/landing/Footer";
import { WhatsAppWidget } from "@/components/landing/WhatsAppWidget";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-white">
      <Header />
      <main>
        <ServiceSelector />
        <GDSection />
        <InstallationSection />
        <Testimonials />
        <LeadForm />
      </main>
      <Footer />
      <WhatsAppWidget />
    </div>
  );
}
